/* Generated. This file cannot be edited directly. Please check codegen.ts for configuration. */
// @ts-nocheck

import { gql } from '@apollo/client'
import * as Types from '../../../../../graphql/src/lib/graphql/generated/types'
export type AdVehicleStreamPassengerCardCustomerInfoFragment = {
  __typename?: 'Customer'
  firstName: string | null
  lastName: string | null
  extendedWalkingTime: boolean
  visualImpairment: boolean | null
}

export type AdVehicleStreamPassengerCardSeatInfoFragment = {
  __typename?: 'FccWaypointSeatInfo'
  seats: number
  wheelchairs: number
  childSeats: number
  boosterSeats: number
}

export type AdVehicleStreamPassengerCardStopInfoFragment = {
  __typename?: 'Stop'
  id: string
  names: Partial<Record<'de' | 'en', string>>
}

export const AdVehicleStreamPassengerCardCustomerInfoFragmentDoc = gql`
    fragment AdVehicleStreamPassengerCardCustomerInfo on Customer {
  firstName
  lastName
  extendedWalkingTime
  visualImpairment
}
    `
export const AdVehicleStreamPassengerCardSeatInfoFragmentDoc = gql`
    fragment AdVehicleStreamPassengerCardSeatInfo on FccWaypointSeatInfo {
  seats
  wheelchairs
  childSeats
  boosterSeats
}
    `
export const AdVehicleStreamPassengerCardStopInfoFragmentDoc = gql`
    fragment AdVehicleStreamPassengerCardStopInfo on Stop {
  id
  names
}
    `
